import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_vendorlots_by_licenseplate_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licenseplateId?: number, materialId?: number, fullTextSearch?: string }): 
  Promise<{ result: { LookupCode?: string, VendorLotId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_vendorlots_by_licenseplate_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licenseplateId?: number, materialId?: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { LookupCode?: string, VendorLotId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_vendorlots_by_licenseplate_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licenseplateId?: number, materialId?: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { LookupCode?: string, VendorLotId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_vendorlots_by_licenseplate_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licenseplateId?: number, materialId?: number, fullTextSearch?: string    }) {
      return false;
    }
}
